export default "__VITE_ASSET__C3pezcE4__"